import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

// Get token from localStorage
const getToken = () => localStorage.getItem('admin_token');

// Set token in axios headers
const setAuthHeader = () => {
  const token = getToken();
  if (token) {
    return { Authorization: `Bearer ${token}` };
  }
  return {};
};

// --- PUBLIC API CALLS ---

export const getActivities = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.searchTerm) params.append('search', filters.searchTerm);
  
  // Gestione zone: se è "Tutte le città" non inviare il parametro
  if (filters.zone && filters.zone !== 'Tutte le città') {
      params.append('zone', filters.zone);
  }
  
  // Gestione categorie: se è "Tutte le categorie" non inviare il parametro
  if (filters.category && filters.category !== 'Tutte le categorie') {
      params.append('category', filters.category);
  }
  
  const response = await axios.get(`${API_URL}/activities?${params}`);
  return response.data;
};

export const getActivityById = async (id) => {
  const response = await axios.get(`${API_URL}/activities/${id}`);
  return response.data;
};

// NUOVO: Recupero Categorie (Pubblico)
export const getCategories = async () => {
  const response = await axios.get(`${API_URL}/categories`);
  return response.data;
};

// --- ADMIN API CALLS ---

export const adminLogin = async (email, password) => {
  const response = await axios.post(`${API_URL}/admin/login`, { email, password });
  if (response.data.access_token) {
    localStorage.setItem('admin_token', response.data.access_token);
  }
  return response.data;
};

export const adminLogout = () => {
  localStorage.removeItem('admin_token');
};

export const isAdminAuthenticated = () => {
  return !!getToken();
};

// Attività Admin (CRUD)
export const getAllActivitiesAdmin = async () => {
  const response = await axios.get(`${API_URL}/admin/activities`, {
    headers: setAuthHeader()
  });
  return response.data;
};

export const createActivity = async (activityData) => {
  const response = await axios.post(`${API_URL}/admin/activities`, activityData, {
    headers: setAuthHeader()
  });
  return response.data;
};

export const updateActivity = async (id, activityData) => {
  const response = await axios.put(`${API_URL}/admin/activities/${id}`, activityData, {
    headers: setAuthHeader()
  });
  return response.data;
};

export const deleteActivity = async (id) => {
  const response = await axios.delete(`${API_URL}/admin/activities/${id}`, {
    headers: setAuthHeader()
  });
  return response.data;
};

// NUOVO: Categorie Admin (CRUD)
export const createCategory = async (data) => {
  const response = await axios.post(`${API_URL}/admin/categories`, data, {
    headers: setAuthHeader()
  });
  return response.data;
};

export const updateCategory = async (id, data) => {
  const response = await axios.put(`${API_URL}/admin/categories/${id}`, data, {
    headers: setAuthHeader()
  });
  return response.data;
};

export const deleteCategory = async (id) => {
  const response = await axios.delete(`${API_URL}/admin/categories/${id}`, {
    headers: setAuthHeader()
  });
  return response.data;
};